import { BaseService } from "./BaseService";

export const AprovacaoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('aprovacao/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos aprovações:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`aprovacao/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de aprovações:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('aprovacao/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir aprovações:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('aprovacao/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar aprovações:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('aprovacao/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar aprovações:', error);
            return false;
        }
    }, 
}